import {
  SEND_EMAIL_POST_REQUEST,
  SEND_EMAIL_POST_SUCCESS,
  SEND_EMAIL_POST_ERROR,
} from 'Redux/types/sendEmailTypes';

const initialState = {
  requestState: {
    isFeching: false,
    message: '',
    statusCode: null,
  },
};
const sendEmail = (state = initialState, actions) => {
  switch (actions.type) {
    case SEND_EMAIL_POST_REQUEST:
      return ({
        ...state,
        requestState: {
          ...initialState.requestState,
          isFeching: true,
        },
      });
    case SEND_EMAIL_POST_SUCCESS:
      return {
        ...state,
        requestState: {
          isFeching: false,
        },
      };
    case SEND_EMAIL_POST_ERROR:
      return ({
        ...state,
        requestState: {
          isFeching: false,
          message: actions.response.data.message,
          statusCode: actions.response.status,
        },
      });
    default:
      return state;
  }
};

export default sendEmail;
